import React from 'react';
import { Text, makeStyles, tokens, Tooltip } from '@fluentui/react-components';
import { Sparkle20Regular, ChevronRight20Regular, ChevronLeft20Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  rail: {
    width: '40px',
    minWidth: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '12px',
    gap: '12px',
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    cursor: 'pointer',
  },
  panel: {
    width: '240px',
    minWidth: '240px',
    padding: '16px',
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  card: {
    padding: '10px 12px',
    borderRadius: '6px',
    border: `1px solid ${tokens.colorNeutralStroke3}`,
    backgroundColor: tokens.colorNeutralBackground3,
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  collapseBtn: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    color: tokens.colorNeutralForeground3,
    ':hover': { color: tokens.colorNeutralForeground1 },
  },
});

const suggestions = [
  'Suggest missing relationships',
  'Generate new semantic view',
  'Explain selected view',
  'Detect grain issues',
];

interface AiAssistantPlaceholderProps {
  collapsed: boolean;
  onToggle: () => void;
}

const AiAssistantPlaceholder: React.FC<AiAssistantPlaceholderProps> = ({ collapsed, onToggle }) => {
  const styles = useStyles();

  if (collapsed) {
    return (
      <Tooltip content="Expand AI Assistant" relationship="label" positioning="after">
        <div className={styles.rail} onClick={onToggle}>
          <Sparkle20Regular />
          <ChevronRight20Regular style={{ color: tokens.colorNeutralForeground3 }} />
        </div>
      </Tooltip>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Sparkle20Regular />
          <Text weight="semibold" size={300}>AI Assistant</Text>
        </div>
        <span className={styles.collapseBtn} onClick={onToggle}>
          <ChevronLeft20Regular />
        </span>
      </div>
      <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>
        AI editing is coming soon.
      </Text>
      {suggestions.map((s) => (
        <div key={s} className={styles.card}>
          <Text size={200}>{s}</Text>
        </div>
      ))}
    </div>
  );
};

export default AiAssistantPlaceholder;